export default __webpack_public_path__ + "static/media/hangot-logo.8aedfeb0.png";